/* eslint-disable prettier/prettier */
export { queryTable_MSCOFFICEMARKETEMAIL } from './MSCOFFICEMARKETEMAIL'
